import { Outlet } from 'react-router-dom';
import { styled } from 'styled-components';

const StyledMainContent = styled.div`
  ${({ theme }) => `
  container-type: inline-size;
  container-name: main-content;
  background: ${theme.colorBgContainer};
  overflow-y: auto;
  padding: ${theme.padding * 2}px;
  height: 100%;
  flex: 1;
  box-sizing: border-box;
  // this line is what prevents it from not expanding to the full width of the page (covers side nav)
  position: relative;
`}
`;

export const MainContent = () => {
  return (
    <StyledMainContent>
      <Outlet />
    </StyledMainContent>
  );
};
